<template>
  <div class="widgets-area">
    <WidgetList :widgets="widgets" />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import WidgetList from '~/components/Widgets/WidgetList.vue';
  import type { TContent } from '~/types/common';

  export default defineNuxtComponent({
    name: 'WidgetsAreaHome',

    components: {
      WidgetList,
    },

    // при необходимости в нужном виджете можем получить его "место обитания"
    provide() {
      return {
        area: () => 'home',
        areaAnalytics: () => '',
      };
    },

    props: {
      widgets: {
        type: Array as PropType<TContent[]>,
        required: true,
      },
    },
  });
</script>
